import eshopSafeCoating from "../assets/safe-coating1.webp";
import eshopSparePart from "../assets/spare-part1.webp";
import eshopPlaygroundEquip from "../assets/equip-2.webp";
import eshopOutdoorEquip from "../assets/equipments/outdoor-sport3.avif";
import eshopSmallArchitecture from "../assets/small-architecture1.webp";
import nordicLawn from "../assets/nordic-lawn-logo.png";
import kdf from "../assets/kdf-logo.png";
import denfitLogo from "../assets/denfit-logo.png";
import technix from "../assets/Technix.png";
import rubrig from "../assets/rubrig.webp";
import dipStationPdf from "../assets/equipments/dip_station/dip_station.pdf";
import parallelBarPdf from "../assets/equipments/parallel_bars/parallel_bars.pdf";
import parallelRailsPdf from "../assets/equipments/parallel_rails/parallel_rails.pdf";
import pullUpPdf from "../assets/equipments/pull_up/pull_up.pdf";
import chinUpPdf from "../assets/equipments/chip_up/chin_up.pdf";
import horizontalLadderPdf from "../assets/equipments/horizontal_ladder/horizontal_ladder.pdf";
import pushUpPdf from "../assets/equipments/push_up/push_up.pdf";
import denfitPdf from "../assets/equipments/denfit/denfit.pdf";
import singleSitUpPdf from "../assets/equipments/single_sit_up/single_sit_up.pdf";

import { EshopInterface } from "../types/Generic";
import {
  auto_smart_1,
  auto_smart_2,
  auto_smart_3,
  auto_smart_4,
  auto_smart_5,
  auto_smart_6,
  auto_smart_7,
  auto_smart_8,
  balanceSwingImg,
  benchesCoverImg,
  bicycleRackImg_1,
  bicycleRackImg_2,
  bicycleRackImg_3,
  carabinerImg_1,
  carabinerImg_2,
  carabinerImg_3,
  castingCoverImg,
  cellularImg_1,
  cellularImg_2,
  chin_up_1,
  chin_up_2,
  chin_up_3,
  cifN100Img_1,
  cifN102brImg_1,
  cifN102Img_1,
  cifN123brImg_1,
  cifN160brImg_1,
  concreteBenchesCoverImg,
  concreteN107brImg_1,
  concreteN107Img_1,
  concreteN115Img_1,
  concreteN131brImg_1,
  concreteN165Img_1,
  connectorCoverImg,
  crossConnectorImg_1,
  crossConnectorImg_2,
  denfitImg_1,
  denfitImg_10,
  denfitImg_11,
  denfitImg_12,
  denfitImg_2,
  denfitImg_3,
  denfitImg_4,
  denfitImg_5,
  denfitImg_6,
  denfitImg_7,
  denfitImg_8,
  denfitImg_9,
  dip_station_1,
  dip_station_2,
  dip_station_3,
  dip_station_4,
  fallProtectionImg,
  greenHybrid22Img,
  greenHybrid32Img,
  hdpeBroncoImg_1,
  hdpeBroncoImg_2,
  hdpeOptimaImg,
  horizontal_ladder_1,
  horizontal_ladder_2,
  horizontal_ladder_3,
  hybridCoverImg,
  iceRinksCoverImg,
  indoorCoatingImg_1,
  indoorCoatingImg_2,
  indoorCoatingImg_3,
  multi_ladder_1,
  multi_ladder_2,
  multi_ladder_3,
  multi_ladder_4,
  multi_ladder_5,
  multi_ladder_6,
  multi_ladder_7,
  multi_ladder_8,
  multiFuncHandleImg_1,
  multiFuncHandleImg_2,
  outdoorCoveringsImg_1,
  outdoorCoveringsImg_2,
  outdoorCoveringsImg_3,
  padsImg_1,
  padsImg_2,
  padsImg_3,
  padsImg_4,
  parallel_bars_1,
  parallel_bars_2,
  parallel_rails_1,
  parallel_rails_2,
  parallel_rails_3,
  partOfBalanceSwingCoverImg,
  pendulumImg,
  plasticCapsCoverImg,
  plasticPostCapImg_1,
  plasticPostCapImg_2,
  plasticPostCapImg_3,
  plasticPostCapImg_4,
  plasticPostCapImg_5,
  plasticScrewCapImg_1,
  plasticScrewCapImg_2,
  plasticScrewCapImg_3,
  plasticScrewCapImg_4,
  plasticScrewCapImg_5,
  pull_up_1,
  pull_up_2,
  pull_up_3,
  push_up_1,
  push_up_2,
  push_up_3,
  qs_1243_1,
  qs_1243_2,
  qs_1243_3,
  qs_1243_4,
  qs_1243_5,
  qs_1243_6,
  qs_1243_7,
  qs_1243_8,
  qs_50_1,
  qs_50_2,
  qs_50_3,
  qs_50_4,
  qs_50_5,
  qs_50_6,
  qs_50_7,
  qs_50_8,
  qs_50_9,
  reinForcedPolyCoverImg,
  reinforcedPolyRopeImg_1,
  reinforcedPolyRopeImg_2,
  reinforcedPolyRopeImg_3,
  round40lImg_1,
  round60lImg_1,
  round70lImg_1,
  rubberSwingSearForToddlersImg_1,
  rubberSwingSearForToddlersImg_2,
  rubberSwingSeatImg_1,
  rubberSwingSeatImg_2,
  seatForBalanceSwingImg_1,
  seatForBalanceSwingImg_2,
  sfN156brImg_1,
  sfN208brImg_1,
  sfN262Img_1,
  shockAbsurbingRubberImg_1,
  shockAbsurbingRubberImg_2,
  single_sit_up_1,
  single_sit_up_2,
  single_sit_up_3,
  springClovisImg_1,
  springClovisImg_2,
  springClovisImg_3,
  springClovisImg_4,
  square70lImg_1,
  stainlessStegImg_1,
  stainlessStegImg_2,
  stainlessStegImg_3,
  stainlessStegOnImg_1,
  stainlessStegOnImg_2,
  stainlessStegOnImg_3,
  stainlessStur1000_1,
  stainlessStur500_1,
  steelFrameBenchesCoverImg,
  swingHookImg_1,
  swingHookImg_2,
  swingSeatCoverImg,
  swingStorksNestImg_1,
  swingStorksNestImg_2,
  teeConnectorImg_1,
  teeConnectorImg_2,
  terra_house_simple_1,
  terra_house_simple_2,
  terra_house_simple_3,
  terra_house_simple_4,
  terra_house_simple_5,
  terra_house_simple_6,
  threeDAnimalImg_1,
  threeDAnimalImg_2,
  threeDAnimalImg_3,
  ticket_office_1,
  ticket_office_2,
  ticket_office_3,
  ticket_office_4,
  ticket_office_5,
  trashCansCoverImg,
} from "../assets";

import hags from "../assets/hags.png";
import playtop from "../assets/playtop.png";
import berliner from "../assets/berliner.png";
import novum from "../assets/novum.png";
import playtopNike from "../assets/playtop-nike.png";

export const functionalControlAccordion = [
  {
    title: "list1Title",
    items: [
      "list1Item1",
      "list1Item2",
      "list1Item3",
      "list1Item4",
      "list1Item5",
      "list1Item6",
      "list1Item7",
      "list1Item8",
      "list1Item9",
      "list1Item10",
      "list1Item11",
      "list1Item12",
      "list1Item13",
    ],
  },
  {
    title: "list2Title",
    items: [
      "list2Item1",
      "list2Item2",
      "list2Item3",
      "list2Item4",
      "list2Item5",
      "list2Item6",
      "list2Item7",
      "list2Item8",
      "list2Item9",
      "list2Item10",
    ],
  },
  {
    title: "list3Title",
    items: ["list3Item1", "list3Item2", "list3Item3", "list3Item4"],
  },
  {
    title: "list4Title",
    items: ["list4Item1"],
  },
];

export const eshopPageData: EshopInterface = {
  heading: "heading",
  description: "desc",
  sections: [
    {
      type: "plain",
      bg: eshopPlaygroundEquip,
      title: "playgroundHeading",
      description: "",
      desc: "playgroundEshopDesc",
      path: "/el-parduotuve/zaidimu-aiksteles",
      products: [
        {
          title: "playgroundsProduct1Title",
          images: [pendulumImg],
          description: "playgroundsProduct1Desc",
          specification: {
            height: "2.40 m",
            width: "1.40 m",
            length: "3.70 m",
            safetyZone: "26 m².",
          },
          partnersReference: [
            { logo: hags, path: "https://www.hags.com/home" },
          ],
        },
        {
          title: "playgroundsProduct2Title",
          images: [
            springClovisImg_1,
            springClovisImg_2,
            springClovisImg_3,
            springClovisImg_4,
          ],
          description: "playgroundsProduct2Desc",
          specification: {
            height: "0.59 m",
            width: "1 m",
            length: "1 m",
            safetyZone: "12.6 m²",
          },
          partnersReference: [
            { path: "http://www.novum4kids.com/", logo: novum },
          ],
        },
        {
          title: "playgroundsProduct3Title",
          images: [balanceSwingImg],
          description: "playgroundsProduct3Desc",
          specification: {
            height: "0.93 m",
            width: "0.28 m",
            length: "3.02 m",
            safetyZone: "10.6 m²",
            freeFallHeight: "0.85 m",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
            { path: "http://www.novum4kids.com/", logo: novum },
            {
              path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
              logo: berliner,
            },
            { path: "https://www.playtop.com/", logo: playtop },
            {
              path: "https://www.playtop.com/products/playtop-with-nike-grind",
              logo: playtopNike,
            },
          ],
        },
        {
          title: "playgroundsProduct4Title",
          images: [
            qs_1243_1,
            qs_1243_2,
            qs_1243_3,
            qs_1243_4,
            qs_1243_5,
            qs_1243_6,
            qs_1243_7,
            qs_1243_8,
          ],
          description: "playgroundsProduct4Desc",
          specification: {
            length: "6.59 m",
            width: "3.82 m",
            height: "3.61 m",
            areaOfSafetyZone: "52 m²",
            perimeterOfSafetyZone: "32 m",
            maximumFallHeight: "1.99 m",
            users: "13",
            userAge: "Min 3 - 14 Max",
          },
          partnersReference: [
            { path: "http://www.novum4kids.com/", logo: novum },
          ],
          price: "€1000 - €2000",
          pdfLInk:
            "https://drive.google.com/file/d/1uSlh9DlZiZsFVbiTLaIOCQct66MtGe4N/view",
        },
        {
          title: "playgroundsProduct5Title",
          images: [
            qs_50_1,
            qs_50_2,
            qs_50_3,
            qs_50_4,
            qs_50_5,
            qs_50_6,
            qs_50_7,
            qs_50_8,
            qs_50_9,
          ],
          description: "playgroundsProduct5Desc",
          specification: {
            length: "4.21 m",
            width: "4.54 m",
            height: "1.86 m",
            areaOfSafetyZone: "38 m²",
            perimeterOfSafetyZone: "26 m",
            maximumFallHeight: "1 m",
            users: "12",
            userAge: "Min 1 - 6 Max",
          },
          partnersReference: [
            { path: "http://www.novum4kids.com/", logo: novum },
          ],
          price: "€1000 - €2000",
          pdfLInk:
            "https://drive.google.com/file/d/1JPs-mX-auosOFtmQ948WsjWcGrkwt5YT/view",
        },
        {
          title: "playgroundsProduct6Title",
          images: [
            ticket_office_1,
            ticket_office_2,
            ticket_office_3,
            ticket_office_4,
            ticket_office_5,
          ],
          description: "playgroundsProduct6Desc",
          specification: {
            length: "1.95 m",
            width: "1.9 m",
            height: "1.72 m",
            areaOfSafetyZone: "22 m²",
            perimeterOfSafetyZone: "17 m",
            maximumFallHeight: "0.72 m",
            users: "10",
            userAge: "Min 1 - 14 Max",
          },
          partnersReference: [
            { path: "http://www.novum4kids.com/", logo: novum },
          ],
          price: "€1000 - €2000",
          pdfLInk:
            "https://drive.google.com/file/d/1TdUvii-IOAspRdD9pCXLj4VIj1K_yNYq/view",
        },
        {
          title: "playgroundsProduct7Title",
          images: [
            auto_smart_1,
            auto_smart_2,
            auto_smart_3,
            auto_smart_4,
            auto_smart_5,
            auto_smart_6,
            auto_smart_7,
            auto_smart_8,
          ],
          description: "playgroundsProduct7Desc",
          specification: {
            length: "2.18 m",
            width: "1.01 m",
            height: "1.32 m",
            areaOfSafetyZone: "19 m²",
            perimeterOfSafetyZone: "16 m",
            maximumFallHeight: "0.29 m",
            users: "6",
            userAge: "Min 3 - 14 Max",
          },
          partnersReference: [
            { path: "http://www.novum4kids.com/", logo: novum },
          ],
          price: "€1000 - €2000",
          pdfLInk:
            "https://drive.google.com/file/d/1C5BV34kGQgZeJnOKpjAfd_Z9kPjf7iRy/view",
        },
        {
          title: "playgroundsProduct8Title",
          images: [
            multi_ladder_1,
            multi_ladder_2,
            multi_ladder_3,
            multi_ladder_4,
            multi_ladder_5,
            multi_ladder_6,
            multi_ladder_7,
            multi_ladder_8,
          ],
          description: "playgroundsProduct8Desc",
          specification: {
            length: "3.02 m",
            width: "1.67 m",
            height: "2.46 m",
            areaOfSafetyZone: "38 m²",
            perimeterOfSafetyZone: "23 m",
            maximumFallHeight: "2.35 m",
            users: "12",
            userAge: "Min 3 - 14 Max",
          },
          partnersReference: [
            { path: "http://www.novum4kids.com/", logo: novum },
          ],
          price: "€1000 - €2000",
          pdfLInk:
            "https://drive.google.com/file/d/1f4MmOcZ4AgieY5I5zD3d15nwSGXu-MJO/view",
        },
        {
          title: "playgroundsProduct9Title",
          images: [
            terra_house_simple_1,
            terra_house_simple_2,
            terra_house_simple_3,
            terra_house_simple_4,
            terra_house_simple_5,
            terra_house_simple_6,
          ],
          description: "playgroundsProduct9Desc",
          specification: {
            length: "1.41 m",
            width: "1.51 m",
            height: "1.79",
            areaOfSafetyZone: "18 m²",
            perimeterOfSafetyZone: "15.3 m",
            maximumFallHeight: "0.67 m",
            users: "4",
            userAge: "Min 1 - 5 Max",
          },
          partnersReference: [
            { path: "http://www.novum4kids.com/", logo: novum },
          ],
          price: "€1000 - €2000",
        },
      ],
    },
    {
      type: "plain",
      bg: eshopOutdoorEquip,
      title: "outdoorSportsHeading",
      description: "",
      desc: "outdoorSportsEshopDesc",
      path: "/el-parduotuve/lauko-sportas",
      products: [
        {
          title: "outdoorSportsProduct1Title",
          images: [
            denfitImg_1,
            denfitImg_2,
            denfitImg_3,
            denfitImg_4,
            denfitImg_5,
            denfitImg_6,
            denfitImg_7,
            denfitImg_8,
            denfitImg_9,
            denfitImg_10,
            denfitImg_11,
            denfitImg_12,
          ],
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
            { path: "https://denfit.nl/", logo: denfitLogo },
          ],
          description: "outdoorSportsProduct1Desc",
          specification: {},
          pdfLInk: denfitPdf,
        },
        {
          title: "outdoorSportsProduct2Title",
          images: [dip_station_1, dip_station_2, dip_station_3, dip_station_4],
          description: "outdoorSportsProduct2Desc",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "1940 mm",
            width: "610 mm",
            height: "800 mm",
            netWeight: "40,00 kg",
            volume: "0.25 m³",
            fallHeight: "800 mm",
            safetyAreaWidth: "3610 mm",
            safetyAreaLength: "4940 mm",
            safetyArea: "16 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: dipStationPdf,
        },
        {
          title: "outdoorSportsProduct3Title",
          images: [parallel_bars_1, parallel_bars_2],
          description: "outdoorSportsProduct3Desc",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "3540 mm",
            width: "670 mm",
            height: "950 mm",
            netWeight: "51,00 kg",
            volume: "0.66 m³",
            fallHeight: "950 mm",
            safetyAreaWidth: "3670 mm",
            safetyAreaLength: "6540 mm",
            safetyArea: "22 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: parallelBarPdf,
        },
        {
          title: "outdoorSportsProduct4Title",
          images: [
            horizontal_ladder_1,
            horizontal_ladder_2,
            horizontal_ladder_3,
          ],
          description: "outdoorSportsProduct4Desc",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "4060 mm",
            width: "810 mm",
            height: "2160 mm",
            netWeight: "70,00 kg",
            volume: "2.66 m³",
            fallHeight: "1150 mm",
            safetyAreaWidth: "3810 mm",
            safetyAreaLength: "7060 mm",
            safetyArea: "25 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: horizontalLadderPdf,
        },
        {
          title: "outdoorSportsProduct5Title",
          images: [single_sit_up_1, single_sit_up_2, single_sit_up_3],
          description: "outdoorSportsProduct5Desc",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "1600 mm",
            width: "410 mm",
            height: "890 mm",
            netWeight: "35,00 kg",
            volume: "0.5 m³",
            fallHeight: "890 mm",
            safetyAreaWidth: "3410 mm",
            safetyAreaLength: "4600 mm",
            safetyArea: "14 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: singleSitUpPdf,
        },
        {
          title: "outdoorSportsProduct6Title",
          images: [chin_up_1, chin_up_2, chin_up_3],
          description: "outdoorSportsProduct6Desc",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "1940 mm",
            width: "60 mm",
            height: "2620 mm",
            netWeight: "35,00 kg",
            volume: "0.87 m³",
            fallHeight: "1260 mm",
            safetyAreaWidth: "3060 mm",
            safetyAreaLength: "4940 mm",
            safetyArea: "14 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: chinUpPdf,
        },
        {
          title: "outdoorSportsProduct7Title",
          images: [parallel_rails_1, parallel_rails_2, parallel_rails_3],
          description: "outdoorSportsProduct7Desc",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "1750 mm",
            width: "540 mm",
            height: "1740 mm",
            netWeight: "159,00 kg",
            volume: "2.73 m³",
            fallHeight: "1460 mm",
            safetyAreaWidth: "3540 mm",
            safetyAreaLength: "4750 mm",
            safetyArea: "15 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: parallelRailsPdf,
        },
        {
          title: "outdoorSportsProduct8Title",
          images: [push_up_1, push_up_2, push_up_3],
          description: "outdoorSportsProduct8Desc",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "2300 mm",
            width: "40 mm",
            height: "450 mm",
            netWeight: "23,00 kg",
            volume: "0.09 m³",
            fallHeight: "450 mm",
            safetyAreaWidth: "4400 mm",
            safetyAreaLength: "5300 mm",
            safetyArea: "22 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: pushUpPdf,
        },
        {
          title: "outdoorSportsProduct9Title",
          images: [pull_up_1, pull_up_2, pull_up_3],
          description: "outdoorSportsProduct9Desc",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "1290 mm",
            width: "920 mm",
            height: "2260 mm",
            netWeight: "84,00 kg",
            volume: "3.54 m³",
            fallHeight: "870 mm",
            safetyAreaWidth: "3920 mm",
            safetyAreaLength: "4300 mm",
            safetyArea: "15 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: pullUpPdf,
        },
      ],
    },
    {
      type: "categorized",
      bg: eshopSparePart,
      title: "sparePartsHeading",
      desc: "sparePartsEshopDesc",
      description: "sparePartsDesc",
      path: "/el-parduotuve/atsargines-dalys",
      subCategories: [
        {
          type: "plain",
          bg: iceRinksCoverImg,
          title: "iceRinksTitle",
          description: "data not available.",
          path: "/el-parduotuve/atsargines-dalys/ice-rinks",
          products: [
            {
              images: [hdpeOptimaImg],
              title: "iceRinksProduct1Title",
              description: "iceRinksProduct1Desc",
              specification: {
                platformHeight: "1500 mm",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              images: [stainlessStur1000_1],
              title: "iceRinksProduct2Title",
              description: "iceRinksProduct2Desc",
              specification: {
                platformHeight: "1000 mm / 1250 mm / 1500 mm",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              images: [stainlessStur500_1],
              title: "iceRinksProduct3Title",
              description: "iceRinksProduct3Desc",
              specification: {
                platformHeight:
                  "1000 mm / 1250 mm / 1500 mm / 2000 mm / 2500 mm;",
                dimensions: "2385 / 2760 / 3182 / 4035 / 4885 x 540 mm.",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              images: [
                stainlessStegImg_1,
                stainlessStegImg_2,
                stainlessStegImg_3,
              ],
              title: "iceRinksProduct4Title",
              description: "iceRinksProduct4Desc",
              specification: {
                platformHeight: "1000 mm / 1250 mm / 1500 mm; ",
                dimensions: "2070 / 2291 / 2716 x 548 mm.",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              images: [
                stainlessStegOnImg_1,
                stainlessStegOnImg_2,
                stainlessStegOnImg_3,
              ],
              title: "iceRinksProduct5Title",
              description: "iceRinksProduct5Desc",
              specification: {
                platformHeight:
                  "600 mm / 1000 mm / 1250 mm / 1500 mm / 2000 mm / 2500 mm; ",
                dimensions: "1470/ 2152/ 2373/ 2799/ 3649/ 4500 x 548 mm.",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              images: [hdpeBroncoImg_1, hdpeBroncoImg_2],
              title: "iceRinksProduct6Title",
              description: "iceRinksProduct6Desc",
              specification: {
                dimensions: "2422 / 3273 x 580 mm.",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
          ],
        },
        {
          type: "plain",
          bg: swingSeatCoverImg,
          title: "swingSeatsTitle",
          description: "Information not available",
          path: "/el-parduotuve/atsargines-dalys/swing-seats",
          products: [
            {
              title: "swingSeatsProduct1Title",
              images: [swingStorksNestImg_1, swingStorksNestImg_2],
              description: "swingSeatsProduct1Desc",
              specification: {
                dimensions: "Ø 1200 / Ø 1000 x 120 mm.",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              title: "swingSeatsProduct2Title",
              images: [
                rubberSwingSearForToddlersImg_1,
                rubberSwingSearForToddlersImg_2,
              ],
              description: "swingSeatsProduct2Desc",
              specification: {
                dimensions: "swingSeatsProduct2Dimension",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              title: "swingSeatsProduct3Title",
              images: [rubberSwingSeatImg_1, rubberSwingSeatImg_2],
              description: "swingSeatsProduct3Desc",
              specification: {
                dimensions: "450 x 180 x 38.5 mm",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
          ],
        },
        {
          type: "categorized",
          bg: reinForcedPolyCoverImg,
          title: "repairPartsTitle",
          description: "repairPartsDesc",
          path: "/el-parduotuve/atsargines-dalys/repair-parts",
          products: [
            {
              title: "repairPartsProduct1Title",
              images: [
                reinforcedPolyRopeImg_1,
                reinforcedPolyRopeImg_2,
                reinforcedPolyRopeImg_3,
              ],
              description: "repairPartsProduct1Desc",
              specification: {
                dimensions: "Ø 16 mm x 220 m.",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
          ],
          subCategories: [
            {
              type: "plain",
              bg: plasticCapsCoverImg,
              title: "plasticCapsTitle",
              path: "/el-parduotuve/atsargines-dalys/repair-parts/plastic-caps",
              products: [
                {
                  title: "plasticCapsProduct1Title",
                  images: [
                    plasticScrewCapImg_1,
                    plasticScrewCapImg_2,
                    plasticScrewCapImg_3,
                    plasticScrewCapImg_4,
                    plasticScrewCapImg_5,
                  ],
                  description: "plasticCapsProduct1Desc",
                  specification: {},
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "plasticCapsProduct2Title",
                  images: [
                    plasticPostCapImg_1,
                    plasticPostCapImg_2,
                    plasticPostCapImg_3,
                    plasticPostCapImg_4,
                    plasticPostCapImg_5,
                  ],
                  description: "plasticCapsProduct2Desc",
                  specification: {
                    dimensions: "plasticCapsProduct2Dimension",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
              ],
            },
            {
              type: "plain",
              bg: connectorCoverImg,
              title: "connectorsTitle",
              path: "/el-parduotuve/atsargines-dalys/repair-parts/connectors",
              products: [
                {
                  title: "connectorProduct1Title",
                  images: [crossConnectorImg_1, crossConnectorImg_2],
                  description: "connectorProduct1Desc",
                  specification: {
                    dimensions: "38 x 50 x 33.5 mm.",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "connectorProduct2Title",
                  images: [teeConnectorImg_1, teeConnectorImg_2],
                  description: "connectorProduct2Desc",
                  specification: {},
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
              ],
            },
            {
              type: "plain",
              bg: partOfBalanceSwingCoverImg,
              title: "partsOfBalanceSwingsTitle",
              path: "/el-parduotuve/atsargines-dalys/repair-parts/parts-of-balance-swings",
              products: [
                {
                  title: "partsOfBalanceSwingsProduct1Title",
                  images: [
                    shockAbsurbingRubberImg_1,
                    shockAbsurbingRubberImg_2,
                  ],
                  description: "partsOfBalanceSwingsProduct1Desc",
                  specification: {
                    dimensions: "150 x 150 x 80 mm.",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "partsOfBalanceSwingsProduct2Title",
                  images: [seatForBalanceSwingImg_1, seatForBalanceSwingImg_2],
                  description: "partsOfBalanceSwingsProduct2Desc",
                  specification: {
                    dimensions: "290 x 235 mm.",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "partsOfBalanceSwingsProduct3Title",
                  images: [multiFuncHandleImg_1, multiFuncHandleImg_2],
                  description: "partsOfBalanceSwingsProduct3Desc",
                  specification: {
                    dimensions: "185 x 175 mm.",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "partsOfBalanceSwingsProduct4Title",
                  images: [carabinerImg_1, carabinerImg_2, carabinerImg_3],
                  description: "partsOfBalanceSwingsProduct4Desc",
                  specification: {
                    dimensions:
                      "Galvanized steel: Stainless steel: - 23 x 12 mm; - 23 x 12 mm; - 20 x 16 mm; - 18 x 12 mm. - 20 x 8 mm; - 18 x 12 mm; - 33 x 19 mm.",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "partsOfBalanceSwingsProduct5Title",
                  images: [swingHookImg_1, swingHookImg_2],
                  description: "partsOfBalanceSwingsProduct5Desc",
                  specification: {
                    dimensions: "265 x 62 x 40 mm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: "categorized",
      bg: eshopSafeCoating,
      title: "safeCoatingsHeading",
      description: "safeCoatingsDesc",
      desc: "safeCoatingsEshopDesc",
      path: "/el-parduotuve/saugios-dangos",
      products: [
        {
          title: "safeCoatingsProduct1Title",
          images: [cellularImg_1, cellularImg_2],
          description: "safeCoatingsProduct1Desc",
          specification: {},
          partnersReference: [
            { logo: technix, path: "https://technix-rubber.com" },
          ],
        },
        {
          title: "safeCoatingsProduct2Title",
          images: [padsImg_1, padsImg_2, padsImg_3, padsImg_4],
          description: "safeCoatingsProduct2Desc",
          specification: {},
          partnersReference: [{ logo: rubrig, path: "https://rubrig.com" }],
        },
      ],
      subCategories: [
        {
          type: "plain",
          bg: hybridCoverImg,
          title: "hybridCoatingsTitle",
          path: "/el-parduotuve/saugios-dangos/hybrid-coatings",
          products: [
            {
              images: [greenHybrid22Img],
              title: "hybridProduct1Title",
              description: "hybridProduct1Desc",
              specification: {},
              partnersReference: [
                { logo: nordicLawn, path: "https://nordiclawn.com/da/" },
              ],
            },
            {
              title: "hybridProduct2Title",
              images: [greenHybrid32Img],
              description: "hybridProduct2Desc",
              specification: {},
              partnersReference: [
                { logo: nordicLawn, path: "https://nordiclawn.com/da/" },
              ],
            },
            {
              title: "hybridProduct3Title",
              images: [fallProtectionImg],
              description: "hybridProduct3Desc",
              specification: {},
              partnersReference: [
                { logo: nordicLawn, path: "https://nordiclawn.com/da/" },
              ],
            },
          ],
        },
        {
          type: "plain",
          bg: castingCoverImg,
          title: "castableCoatingTitle",
          path: "/el-parduotuve/saugios-dangos/castable-coatings",
          products: [
            {
              title: "castableProduct1Title",
              images: [
                indoorCoatingImg_1,
                indoorCoatingImg_2,
                indoorCoatingImg_3,
              ],
              description: "castableProduct1Desc",
              specification: {},
              partnersReference: [
                { logo: kdf, path: "https://www.kdf.gr/en/" },
                { logo: playtop, path: "https://www.playtop.com" },
              ],
            },
            {
              title: "castableProduct2Title",
              images: [
                outdoorCoveringsImg_1,
                outdoorCoveringsImg_2,
                outdoorCoveringsImg_3,
              ],
              description: "castableProduct2Desc",
              specification: {},
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              title: "castableProduct3Title",
              images: [threeDAnimalImg_1, threeDAnimalImg_2, threeDAnimalImg_3],
              description: "castableProduct3Desc",
              specification: {},
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: "categorized",
      bg: eshopSmallArchitecture,
      title: "smallArchitectureHeading",
      description: "smallArchitectureDesc",
      desc: "smallArchitectureEshopDesc",
      path: "/el-parduotuve/mazoji-architektura",
      products: [
        {
          title: "smallArchitectureProduct1Title",
          images: [bicycleRackImg_1, bicycleRackImg_2, bicycleRackImg_3],
          description: "Information not available",
          specification: {
            height: "0.55 m",
            width: "0.14 m",
            length: "2 m",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
            { path: "http://www.novum4kids.com/", logo: novum },
            {
              path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
              logo: berliner,
            },
            { path: "https://www.playtop.com/", logo: playtop },
            {
              path: "https://www.playtop.com/products/playtop-with-nike-grind",
              logo: playtopNike,
            },
          ],
        },
      ],
      subCategories: [
        {
          type: "plain",
          bg: trashCansCoverImg,
          title: "trashCansTitle",
          description: "Information not available",
          desc: "Concrete trash cans with natural granite finish; made of Portland cement",
          path: "/el-parduotuve/mazoji-architektura/trash-cans",
          products: [
            {
              title: "trashCansProduct1Title",
              images: [round40lImg_1],
              description: "trashCansProduct1Desc",
              specification: {
                height: "62 cm",
                bottomDiameter: "52cm",
                topDiameter: "45 cm",
                weight: "130 kg",
                boxCapacity: "50 l",
                boxCapacityWithInsert: "40 l",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              title: "trashCansProduct2Title",
              images: [round60lImg_1],
              description: "trashCansProduct2Desc",
              specification: {
                height: "81 cm",
                diameter: "62.5 cm",
                weight: "320 kg",
                boxCapacity: "75 l",
                boxCapacityWithInsert: "60 l",
                boxCapacityWithLid: "55l",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              title: "trashCansProduct3Title",
              images: [round70lImg_1],
              description: "trashCansProduct3Desc",
              specification: {
                height: "72 cm",
                diameter: "53 cm",
                weight: "180 kg",
                boxCapacity: "80 l",
                boxCapacityWithInsert: "70 l",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              title: "trashCansProduct4Title",
              images: [square70lImg_1],
              description: "trashCansProduct4Desc",
              specification: {
                height: "80 cm",
                bottom: "45 cm x 45 cm",
                weight: "175 kg",
                boxCapacity: "70 l",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
          ],
        },
        {
          type: "categorized",
          bg: benchesCoverImg,
          title: "benchesTitle",
          description: "benchesDesc",
          desc: "Benches, trash cans",
          path: "/el-parduotuve/mazoji-architektura/benches",
          subCategories: [
            {
              type: "plain",
              bg: concreteBenchesCoverImg,
              title: "concreteBenchesTitle",
              desc: "Concrete benches with natural granite finish; made of Portland cement. Seat – 10 cm wide and 4 cm thick alder or ash wood slats, painted 3 times with modern, environmentally friendly varnish. Steel seat parts, galvanized and powder-coated",
              path: "/el-parduotuve/mazoji-architektura/benches/concrete-benches",
              products: [
                {
                  title: "concreteBenchProduct1Title",
                  images: [concreteN107Img_1],
                  description: "concreteBenchProduct1Desc",
                  specification: {
                    height: "44 cm",
                    totalLength: "210 cm",
                    lengthOfWoodenPart: "180 cm",
                    width: "40 cm",
                    weight: "180 kg",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "concreteBenchProduct2Title",
                  images: [concreteN107brImg_1],
                  description: "concreteBenchProduct2Desc",
                  specification: {
                    seatHeight: "44 cm",
                    totalHeight: "78 cm",
                    totalLength: "210 cm",
                    lengthOfWoodenPart: "180 cm",
                    width: "40 cm",
                    weight: "200 kg",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "concreteBenchProduct3Title",
                  images: [concreteN131brImg_1],
                  description: "concreteBenchProduct3Desc",
                  specification: {
                    seatHeight: "44 cm",
                    totalHeight: "77 cm",
                    lengthOfWoodenPart: "180 cm",
                    seatWidth: "40 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "concreteBenchProduct4Title",
                  images: [concreteN165Img_1],
                  description: "concreteBenchProduct4Desc",
                  specification: {
                    height: "42 cm",
                    lengthOfWoodenPart: "191.5 cm",
                    seatWidth: "37.5 cm",
                    weight: "140 kg",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "concreteBenchProduct5Title",
                  images: [concreteN115Img_1],
                  description: "concreteBenchProduct5Desc",
                  specification: {
                    height: "44 cm",
                    length: "4 x 180 cm ",
                    seatWidth: "41 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
              ],
            },
            {
              type: "plain",
              bg: steelFrameBenchesCoverImg,
              title: "steelFrameBenchesTitle",
              desc: "The seat is made of 4 cm thick wooden slats, painted 3 times with a modern, environmentally friendly varnish. The bench frame is made of galvanized steel sheet and powder coated",
              path: "/el-parduotuve/mazoji-architektura/benches/steel-frame-benches",
              products: [
                {
                  title: "steelFrameBenchProduct1Title",
                  images: [sfN156brImg_1],
                  description: "steelFrameBenchProduct1Desc",
                  specification: {
                    height: "43 cm",
                    totalHeight: "76 cm",
                    totalLength: "205 cm",
                    lengthOfWoodenPart: "180 cm",
                    width: "45 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "steelFrameBenchProduct2Title",
                  images: [sfN208brImg_1],
                  description: "steelFrameBenchProduct2Desc",
                  specification: {
                    height: "45 cm",
                    totalHeight: "79 cm",
                    totalLength: "180 cm",
                    width: "55 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "steelFrameBenchProduct3Title",
                  images: [sfN262Img_1],
                  description: "steelFrameBenchProduct3Desc",
                  specification: {
                    height: "45 cm",
                    totalHeight: "79 cm",
                    totalLength: "180 cm",
                    width: "55 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
              ],
            },
            {
              type: "plain",
              bg: castingCoverImg,
              title: "castIronFrameBenchesTitle",
              desc: "The seat is made of 4 cm thick wooden slats, painted 3 times with a modern, environmentally friendly varnish. The base is cast iron, coated with primer and top coat",
              path: "/el-parduotuve/mazoji-architektura/benches/cast-iron-frame-benches",
              products: [
                {
                  title: "ironFrameBenchProduct1Title",
                  images: [cifN123brImg_1],
                  description: "ironFrameBenchProduct1Desc",
                  specification: {
                    height: "42 cm",
                    totalHeight: "74 cm",
                    totalLength: "180 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "ironFrameBenchProduct2Title",
                  images: [cifN102brImg_1],
                  description: "ironFrameBenchProduct2Desc",
                  specification: {
                    height: "41 cm",
                    totalHeight: "70 cm",
                    totalLength: "180 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "ironFrameBenchProduct3Title",
                  images: [cifN102Img_1],
                  description: "ironFrameBenchProduct3Desc",
                  specification: {
                    height: "42 cm",
                    width: "58 cm",
                    totalLength: "180 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "ironFrameBenchProduct4Title",
                  images: [cifN100Img_1],
                  description: "ironFrameBenchProduct4Desc",
                  specification: {
                    height: "42 cm",
                    width: "58 cm",
                    totalLength: "230 cm",
                    seatLength: "180 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "ironFrameBenchProduct5Title",
                  images: [cifN160brImg_1],
                  description: "ironFrameBenchProduct5Desc",
                  specification: {
                    height: "43 cm",
                    totalHeight: "75 cm",
                    totalLength: "180 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
